package com.playoffpulse.shared.logic

import com.playoffpulse.shared.model.BlockedShotsMissesMode

fun BlockedShotsMissesMode.displayLabel(): String = when (this) {
    BlockedShotsMissesMode.EXCLUDE -> "Exclude Misses"
    BlockedShotsMissesMode.INCLUDE -> "Include Misses"
}

fun BlockedShotsMissesMode.queryValue(): String = when (this) {
    BlockedShotsMissesMode.EXCLUDE -> "exclude"
    BlockedShotsMissesMode.INCLUDE -> "include"
}

fun blockedShotsMissesModeFromQueryValue(value: String?): BlockedShotsMissesMode? {
    return when (value?.trim()?.lowercase()) {
        "exclude" -> BlockedShotsMissesMode.EXCLUDE
        "include" -> BlockedShotsMissesMode.INCLUDE
        else -> null
    }
}
